// /* global fbq */
// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';

// Import Bootstrap JS (optional, for components like modals, tooltips, etc.)
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { store } from './store/store';
import './assets/global.scss';
import { FontAwesomeIcon } from './fontawesome';
import { createHead } from '@vueuse/head'
import { analytics } from './services/analytics';

const head = createHead()

let firstNavigation = true
router.afterEach(() => {
  if (firstNavigation) {
    firstNavigation = false
    return
  }
  analytics.pageView()
})

const VERSION = "1.0.2";

if (localStorage.getItem("site_version") !== VERSION) {
  localStorage.clear();
  localStorage.setItem("site_version", VERSION);
  window.location.reload();
}

// Restore Meta Pixel advanced matching for an already-logged-in user on reload.
analytics.identify(store.state.user)

createApp(App)
  .component('font-awesome-icon', FontAwesomeIcon)
  .use(head)
  .use(store)
  .use(router)
  .mount('#app');
